(function ($) {

    window.onhashchange = scrollToHash;
    $(document).ready(scrollToHash);
    $(document).on('click', '.scroll-to', scrollToHash);

    function scrollToHash() {
        const anchor = $(location).attr('hash').replace('#', '');
        if (anchor) {
            const $anchor = $($('.' + anchor).first());
            const speed = 750;
            const offset = Math.max($anchor.offset().top, 0);
            $('html, body').animate({scrollTop: offset}, speed);
        }
    }
})(jQuery);